import BaseApi from './BaseApi';

export type Profile = {
  fileData?: File;
  body?: { name: string; bucketName: string };
};

/**
 * アカウントプロファイル設定API。
 */
class UpdateStaffSettingApi extends BaseApi {
  async send(details: Profile) {
    const formData = this.buildFormData(details);
    return await this.execute(
      'updateStaffSettingApi',
      {
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        body: formData
      },
      true
    ).then(({ status }) => status === 1);
  }
}

export default UpdateStaffSettingApi;
